import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { useSelector, useDispatch } from "react-redux";
import { setRecentEntry } from "../actions/searchAction";


//Ref: https://react-select.com/props

export const DetailHistoryCombobox = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const styles = {
    control: (css) => ({ ...css, width: "350px" })
  }


  let options = [];
  state.detailsHistory.forEach(d => {
    options.push({ value: d.id, label: d.id });
  });


  return (
    <div>
      <CreatableSelect
        styles={styles}
        options={options}
        defaultValue={{ label: `${state.selectedDetails.id}`, value: `${state.selectedDetails.id}` }}
        onChange={(newValue, actionMeta) => dispatch(setRecentEntry(newValue.value))} />
    </div>
  );
}
